import api from './api'
import axios from 'axios'
import { authService } from './authService'
import { normalizeOssUrlForPresign } from '@/utils/ossUrl'

// 创建用于文件上传的axios实例
const uploadApi = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '/api',
  timeout: 600000, // 10分钟超时，足够处理大文件上传到OSS
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

// 文件上传请求拦截器
uploadApi.interceptors.request.use((config) => {
  // 检查token是否已过期
  if (authService.isTokenExpired()) {
    localStorage.removeItem('user')
    window.location.href = '/'
    return Promise.reject(new Error('Token已过期'))
  }
  
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  if (user.token) {
    config.headers.Authorization = `Bearer ${user.token}`
  }
  return config
}, error => Promise.reject(error))

// 文件上传响应拦截器
uploadApi.interceptors.response.use(
  (response) => {
    if (response.data && response.data.success !== undefined) {
      return response.data
    }
    return response
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response
      if (status === 401) {
        localStorage.removeItem('user')
        window.location.href = '/'
      }
      console.error('上传失败:', data?.message || error.message)
    }
    return Promise.reject(error)
  }
)

export const courseService = {
  fetchCourses(params = {}) {
    const query = new URLSearchParams()
    const { page = 0, size = 10, keyword, status, startFrom, endTo } = params
    query.append('page', page)
    query.append('size', size)
    if (keyword) query.append('keyword', keyword)
    if (status) query.append('status', status)
    if (startFrom) query.append('startFrom', startFrom)
    if (endTo) query.append('endTo', endTo)
    return api.get(`/courses?${query.toString()}`)
  },

  fetchCourse(id) {
    return api.get(`/courses/${id}`)
  },

  fetchPublicCourses() {
    return api.get('/courses/public')
  },

  createCourse(payload) {
    return api.post('/courses', payload)
  },

  updateCourse(id, payload) {
    return api.put(`/courses/${id}`, payload)
  },

  deleteCourse(id) {
    return api.delete(`/courses/${id}`)
  },

  uploadImage(file) {
    const formData = new FormData()
    formData.append('file', file)
    return uploadApi.post('/courses/images/upload', formData)
  },

  getPresignedUrl(imageUrl) {
    const clean = normalizeOssUrlForPresign(imageUrl)
    return api.get(`/courses/images/presigned-url?url=${encodeURIComponent(clean)}`)
  }
}

